var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entrance"},[_c('div',{staticClass:"bac"}),_c('div',{staticClass:"content"},[_c('login')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }